<template>
  <party-template :type="2"/>
</template>

<script>
import PartyTemplate from '@/views/basedata/parties/PartyTemplate.vue'

export default {
  name: 'SupplierBaseData',
  components: { PartyTemplate }
}
</script>